import React, { useMemo, useState } from "react";
import moment from "moment/moment";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../../designsystem/KC_Button/KC_Button";
import KC_Tabs from "../../../../designsystem/KC_Tabs/KC_Tabs";
import { POSAMode } from "../POSAEditor/model";
import OnlinePOSAGallery from "./OnlinePOSAGallery";
import OfflinePOSAGallery from "./component/OfflinePOSAGallery";
import { useJetpackConfigSelector } from "../../../../redux/jetpackConfig";
import TSUtils from "../../../../utils/helpers/TSUtils";
import BusinessUser from "@tootsweet/model/entities/BusinessUser";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";
import { FullScreenLoader } from "../../../../components/Loaders/FullScreenLoader/FullScreenLoader";
import MobileDashboardHeader from "../../../Layout/Mobile/MobileDashboardHeader";
import { tt } from "../../../../utils/i18n/i18n";
import { generateBasicQRCode } from "../../../../utils/helpers/generateBasicQRCode";

const POSA_TYPE = [
  { name: tt("posa_mode_offline"), value: POSAMode.Offline },
  { name: tt("posa_mode_online"), value: POSAMode.Online }
];

export default function POSAGallery() {
  const jetpackConfig = useJetpackConfigSelector();
  const { accountToDisplay } = useAccountToDisplaySelector();
  const [mode, setMode] = useState(POSAMode.Offline);
  const [isInit, setIsInit] = useState(true);

  const handleSelectType = (value: string) => {
    setMode(value as POSAMode);
  };

  const buildBasicQRCodeName = (bu: BusinessUser) => {
    const now = TSUtils.timestampToDateString(moment().unix());
    return `basic_qrcode_${bu.placeName}_${now}`;
  };

  const POSA_LIST = useMemo(() => {
    switch (mode) {
      case POSAMode.Offline:
        return <OfflinePOSAGallery />;

      case POSAMode.Online:
        return <OnlinePOSAGallery />;
    }
  }, [mode]);

  const displayTabSelector = useMemo(() => {
    return !!accountToDisplay?.saasFeatures?.cp;
  }, [accountToDisplay]);

  if (!isInit) {
    return <FullScreenLoader loading={true} />;
  }

  return (
    <div className="d-flex flex-column h-100 dashboard-v2">
      <MobileDashboardHeader
        title={tt("onboarding_choose_distribution_name")}
        description={tt("posa_gallery_description")}
      />
      <div className="d-flex flex-column flex-sm-row st-gap w-100 p-4 justify-content-between">
        <div
          className="d-flex"
          style={{
            opacity: displayTabSelector ? 1 : 0,
            pointerEvents: displayTabSelector ? undefined : "none"
          }}
        >
          <KC_Tabs
            items={POSA_TYPE}
            onSelect={handleSelectType}
            initialSelectedIndex={0}
            className={
              "d-flex d-sm-none w-100 align-items-center justify-content-center "
            }
          />
          <KC_Tabs
            id="online"
            items={POSA_TYPE}
            onSelect={handleSelectType}
            initialSelectedIndex={0}
            className="d-none d-sm-flex w-100"
          />
        </div>

        {mode === POSAMode.Offline && (
          <div className="d-flex gap-sm">
            <KC_Button
              id="posa-download-qr-code"
              size={KC_ButtonSize.Large}
              isInverted={true}
              showIconOnTheLeft={true}
              icon={faQrcode}
              text={tt("posa_download_qr_code")}
              type={KC_ButtonType.Button}
              onClick={() => {
                if (!accountToDisplay?.businessUser) {
                  alert(tt("error"));
                  return;
                }
                return generateBasicQRCode(
                  jetpackConfig?.configId,
                  buildBasicQRCodeName(accountToDisplay.businessUser)
                );
              }}
              className="d-flex"
            />
          </div>
        )}
      </div>

      <div className="flex-grow-1 d-flex flex-column position-relative">
        {POSA_LIST}
      </div>
    </div>
  );
}
